var ProgressService = function() {
  this.saveProgress = function(model, page, cb) {
    var act = typeof page.activity !== 'undefined';
    var ind = typeof page.get('index') !== 'undefined';
    var key = typeof page.get('key') !== 'undefined';
    if(act && ind && key) {
      model.get('module').setLastCompletedPage(page);
    }
    if(cb) { cb(); }
  };

  this.getPath = function(eid) {
    return `/sdk/enrollments/${eid}/page_progresses.json`;
  };

  this.getRequestOptions = function(request) {
   return {
      dataType: 'json',
      type: 'POST',
      url: request.url,
      data: request.data
    };
  };

  this.saveActivityProgress = function(model, grade, attempt, slug) {
    model.saveActivityProgress(grade, attempt, slug);
  };
};

module.exports = new ProgressService();